module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "head"
  }, [_c('div', {
    staticClass: "cent"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v("LOGO")]), _vm._v(" "), _c('div', {
    staticClass: "cent_cet"
  }, _vm._l((_vm.headlist), function(item, index) {
    return _c('div', {
      staticClass: "cee",
      class: _vm.tindex == index ? 'sty' : '',
      on: {
        "click": function($event) {
          return _vm.jumphead(item)
        }
      }
    }, [_vm._v("\n          " + _vm._s(item.name) + "\n          "), (item.childlist) ? _c('div', {
      staticClass: "cee_cent"
    }, _vm._l((item.childlist), function(eitem) {
      return _c('div', {
        staticClass: "ctt",
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.jumphead(eitem)
          }
        }
      }, [_vm._v("\n              " + _vm._s(eitem.name) + "\n            ")])
    }), 0) : _vm._e()])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('el-popconfirm', {
    attrs: {
      "title": "这是一段内容确定删除吗？"
    }
  }, [_c('div', {
    attrs: {
      "slot": "reference"
    },
    slot: "reference"
  }, [_vm._v("大大 "), _c('i', {
    staticClass: "el-icon-arrow-down"
  })])])], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-be1c6922"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/head/header.vue
// module id = 1112
// module chunks = 1